import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { resetStatus } from "../redux/organizationsSagas";
import { MainModal } from "../../../../components/modal/MainModal";
import { ErrorList } from "../../../../components/ErrorList";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import { showToast } from "../../../../utils/showToast";
import { useError } from "../../../../hooks/useError";
import { useAdd } from "../hooks/useAdd";
import { TABS } from "../constants";

export const Add = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("General");

  const {
    register,
    submit,
    control,
    formState: { errors, isSubmitting },
    watchedValues
  } = useAdd();

  const [showFutureAppointments, membershipMetric] = watchedValues;

  const close = () => {
    dispatch(resetStatus());
    onClose();
  };

  const { errors: serverErrors, status } = useError({
    cb: () => {
      showToast("Organization was successfully created");
      close();
    },
    sliceKey: "organizations"
  });

  const primaryButtonDisabled = isSubmitting || status == "pending";

  const renderActiveTab = () => {
    let Component = TABS[activeTab];
    let retentionProps = activeTab === "Retention" ? { showFutureAppointments } : {};
    let clubreadyProps = activeTab === "ClubReady" ? { membershipMetric } : {};
    return (
      <Component register={register} control={control} {...retentionProps} {...clubreadyProps} />
    );
  };

  return (
    <>
      <MainModal
        isOpen={isOpen}
        onClose={close}
        parentSelector=".admin-organizations"
        headerText="Add Organization"
        headerCloseHandler={close}
        bodyClassName="main-popup-body"
        primaryButtonText="Save"
        primaryButtonDisabled={primaryButtonDisabled}
        primaryBtnHandler={submit}
        containerClassName="add"
        secondaryBtnText="Cancel"
        secondaryBtnHandler={close}
        height={645}
        width={900}
      >
        <div className="tabs">
          <div className="tabs__list">
            {Object.entries(TABS).map(([tabName]) => (
              <button
                key={tabName}
                className={`tabs__tab ${activeTab === tabName ? "tabs__tab--active" : ""}`}
                onClick={() => setActiveTab(tabName)}
              >
                {tabName}
              </button>
            ))}
          </div>

          <div>{renderActiveTab()}</div>
        </div>

        {status === "pending" && <LoadingAnimation uiLoader />}
        <ErrorList errors={{ ...errors, ...serverErrors }} />
      </MainModal>
    </>
  );
};
